// The frame around every learner screen: the sidebar, its foot, and the few
// states the shell draws itself (loading, not found).

import { defineMessages } from './index'

export default defineMessages(
  {
    mainNavigation: 'Asosiy menyu',
    skipToContent: 'Asosiy qismga o‘tish',
    home: 'Bosh sahifa',
    myCourses: 'Kurslarim',
    leaderboard: 'Reyting',
    settings: 'Sozlamalar',
    signOut: 'Chiqish',
    signedInAs: '{name} sifatida kirgansiz',
    loading: 'Yuklanmoqda…',
    notFoundTitle: 'Sahifa topilmadi',
    notFoundBody: 'Manzilni tekshirib ko‘ring yoki kurslaringiz ro‘yxatiga qayting.',
    backToCourses: 'Kurslarimga qaytish',
  },
  {
    en: {
      mainNavigation: 'Main navigation',
      skipToContent: 'Skip to content',
      home: 'Home',
      myCourses: 'My courses',
      leaderboard: 'Leaderboard',
      settings: 'Settings',
      signOut: 'Sign out',
      signedInAs: 'Signed in as {name}',
      loading: 'Loading…',
      notFoundTitle: 'Page not found',
      notFoundBody: 'Check the address or go back to your courses.',
      backToCourses: 'Back to my courses',
    },
    ru: {
      mainNavigation: 'Основное меню',
      skipToContent: 'Перейти к содержимому',
      home: 'Главная',
      myCourses: 'Мои курсы',
      leaderboard: 'Рейтинг',
      settings: 'Настройки',
      signOut: 'Выйти',
      signedInAs: 'Вы вошли как {name}',
      loading: 'Загрузка…',
      notFoundTitle: 'Страница не найдена',
      notFoundBody: 'Проверьте адрес или вернитесь к списку своих курсов.',
      backToCourses: 'К моим курсам',
    },
    de: {
      mainNavigation: 'Hauptnavigation',
      skipToContent: 'Zum Inhalt springen',
      home: 'Startseite',
      myCourses: 'Meine Kurse',
      leaderboard: 'Rangliste',
      settings: 'Einstellungen',
      signOut: 'Abmelden',
      signedInAs: 'Angemeldet als {name}',
      loading: 'Wird geladen…',
      notFoundTitle: 'Seite nicht gefunden',
      notFoundBody: 'Prüfen Sie die Adresse oder kehren Sie zu Ihren Kursen zurück.',
      backToCourses: 'Zu meinen Kursen',
    },
  },
)
